module.exports = __webpack_public_path__ + "img/imdb.e6a7d4e1.svg";